import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3893789e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "washing-mark-select-title" }
const _hoisted_2 = {
  key: 0,
  class: "select-content"
}
const _hoisted_3 = { width: "240" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "must" }, "*", -1))
const _hoisted_5 = { width: "240" }
const _hoisted_6 = { style: {"max-width":"200px"} }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/question1.png",
  alt: "",
  class: "cursor-pt"
}, null, -1))
const _hoisted_8 = { class: "th-title" }
const _hoisted_9 = { style: {"max-width":"200px"} }
const _hoisted_10 = { class: "error-tip" }
const _hoisted_11 = {
  key: 0,
  class: "error-tip",
  style: {"top":"48px"}
}
const _hoisted_12 = {
  key: 1,
  class: "error-tip",
  style: {"top":"48px"}
}
const _hoisted_13 = {
  key: 0,
  style: {"font-size":"12px","color":"#FE2C55","text-align":"left","flex":"1","position":"absolute","top":"48px","line-height":"1.2"}
}
const _hoisted_14 = { class: "td-preview" }
const _hoisted_15 = { class: "preview-content" }
const _hoisted_16 = {
  key: 1,
  class: "d2c-form"
}
const _hoisted_17 = { class: "text" }
const _hoisted_18 = { style: {"max-width":"200px"} }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/question1.png",
  alt: "",
  class: "cursor-pt"
}, null, -1))
const _hoisted_20 = {
  key: 0,
  style: {"font-size":"12px","color":"#FE2C55"}
}

import { t } from '@/plugins/i18n'
import { isD2C, isJA } from '@/store'
import { ref, reactive, computed } from 'vue'
import { getWashingMarkList } from '@/apis/setup'
import Tipstishi from '@/components/IconPark/Tipstishi.vue'
import WashingMarkPreview from '@/components/additional/WashingMarkPreview.vue'
import { getSkuWashInfoApi } from '@/apis/order'
import bus from '@/util/useBus'
import { useRoute } from 'vue-router'
interface WASH_TYPE {
  washedlabelAdditionId: string,
  washedlabelName?: string,
  shopAddressWashedlabelId?: string
}

export default /*#__PURE__*/_defineComponent({
  props: ['addition', 'product', 'isBatchEdit'],
  setup(__props, { expose }) {

const props = __props
const route = useRoute()

const isGroupUrl = computed(() => {
  return route.path.includes('/group') || (props.isBatchEdit && route.path.includes('/CombinedGoods'))
})
const formRef = ref()
const form = reactive({
  washedlabelSpecification: '',
  washedlabelAdditionId: ''
})
const rules = {
  // washedlabelSpecification: [{ required: true, message: '', trigger: 'blur' }],
  washedlabelAdditionId: [{ required: true, message: '', trigger: 'blur' }]
}
const washList = ref<WASH_TYPE[]>([])

const check = async () => {
  const res = await formRef.value.validate((valid: any, fields: any) => { })
  if (res) {
    return {
      ...form,
      washedlabelName: washList.value.find((v) => v.washedlabelAdditionId === form.washedlabelAdditionId)?.washedlabelName
    }
  }
  return false
}

// 是否下过订单
const isCreateOrder = ref(false)
const init = async () => {
  const { washedlabelAdditionId, washedlabelSpecification } = props.addition
  form.washedlabelAdditionId = washedlabelAdditionId ?? ''
  form.washedlabelSpecification = washedlabelSpecification ?? ''
  const washInfo = await getList()
  // 下过单的禁止选中并更换
  isCreateOrder.value = props.isBatchEdit ? false : (washInfo.ordered !== 0)
  form.washedlabelSpecification = washedlabelSpecification ?? washInfo.washedlabelSpecification ?? ''
  if (!isCreateOrder.value && (!washedlabelAdditionId || washedlabelAdditionId === '-')) {
    // 没下过单取默认的水洗标
    const defaultWash = isD2C() ? washList.value?.[0] : washList.value.find((v: any) => v.isDefault === 1)
    form.washedlabelAdditionId = defaultWash?.washedlabelAdditionId ?? ''
  }
  if (isCreateOrder.value) {
    // 下过单取list第一个水洗标
    form.washedlabelAdditionId = washList.value?.[0]?.washedlabelAdditionId ?? ''
  }
}
const getList = async () => {
  if (props.product?.productSku) {
    // 获取下单过的sku水洗标信息
    const { data: washInfo } = await getSkuWashInfoApi({
      productSku: props.product?.productSku
    })
    washList.value = washInfo.list ?? []
    return washInfo
  }
  if (props.isBatchEdit) {
    const { data: list } = await getWashingMarkList()
    washList.value = list ?? []
  }
  return {}
}
bus.on('updateWashMark', () => {
  //  无水洗标新建时选择
  getList()
})
init()
expose({
  check
})

return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", {
    class: "washing-mark-select",
    style: _normalizeStyle({marginBottom: (__props.isBatchEdit || (!__props.isBatchEdit && _unref(isGroupUrl))) ? '50px' : ''})
  }, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(isD2C)() ? _unref(t)('水洗标信息') : _unref(t)('选择水洗标')), 1),
    _createVNode(_component_el_form, {
      model: _unref(form),
      rules: rules,
      ref: (_value, _refs) => {
        _refs['formRef'] = _value
        formRef.value = _value
      }
    }, {
      default: _withCtx(() => [
        (!_unref(isD2C)())
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("table", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", _hoisted_3, [
                    _hoisted_4,
                    _createElementVNode("span", null, _toDisplayString(_unref(t)('水洗标名称')), 1)
                  ]),
                  _createElementVNode("th", _hoisted_5, [
                    _createElementVNode("span", null, _toDisplayString(_unref(t)('客户商品规格')), 1),
                    _createVNode(_component_el_tooltip, {
                      effect: "light",
                      placement: "top",
                      "popper-class": "tool-tip-no-border"
                    }, {
                      content: _withCtx(() => [
                        _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)('填写的客户商品规格将打印在水洗标上')), 1)
                      ]),
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("th", _hoisted_8, _toDisplayString(_unref(t)('水洗标图片')), 1)
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, [
                    _createVNode(_component_el_form_item, { prop: "washedlabelAdditionId" }, {
                      error: _withCtx(() => [
                        _createElementVNode("div", _hoisted_10, [
                          _createVNode(Tipstishi, {
                            color: "#F5222D",
                            size: 14,
                            class: "icon-park"
                          }),
                          _createElementVNode("span", null, _toDisplayString(_unref(t)('请选择水洗标')), 1)
                        ])
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          placeholder: _unref(t)('请选择'),
                          style: {"width":"200px"},
                          "popper-class": "washing-market-select-com",
                          modelValue: _unref(form).washedlabelAdditionId,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).washedlabelAdditionId) = $event)),
                          disabled: isCreateOrder.value || _unref(isGroupUrl)
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(washList.value, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.washedlabelAdditionId,
                                value: item.washedlabelAdditionId!,
                                label: item.washedlabelName ?? _unref(t)('水洗标')
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_tooltip, {
                                    effect: "light",
                                    placement: "top",
                                    "popper-class": "tool-tip-no-border"
                                  }, {
                                    content: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_9, _toDisplayString(item.washedlabelName ?? _unref(t)('水洗标')), 1)
                                    ]),
                                    default: _withCtx(() => [
                                      _createElementVNode("span", null, _toDisplayString(item.washedlabelName ?? _unref(t)('水洗标')), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1032, ["value", "label"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["placeholder", "modelValue", "disabled"]),
                        (__props.isBatchEdit)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                              _createElementVNode("span", null, _toDisplayString(_unref(isGroupUrl) ? _unref(t)('注意：如需修改水洗标模版，请加入购物车后修改') : _unref(t)('注意：批量水洗标模版功能，只对未下过单的商品生效')), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (!__props.isBatchEdit && _unref(isGroupUrl))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                              _createElementVNode("span", null, _toDisplayString(_unref(t)('注意：如需修改水洗标模版，请加入购物车后修改')), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("td", null, [
                    _createVNode(_component_el_form_item, {
                      prop: "washedlabelSpecification",
                      style: {"position":"relative"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          placeholder: _unref(t)('示例：L码，红色等'),
                          class: "sku-input",
                          modelValue: _unref(form).washedlabelSpecification,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).washedlabelSpecification) = $event)),
                          maxlength: 20,
                          disabled: __props.isBatchEdit
                        }, null, 8, ["placeholder", "modelValue", "disabled"]),
                        (__props.isBatchEdit)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_unref(t)('无法批量操作，请去单个商品上维护')), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("td", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(WashingMarkPreview, {
                        washData: washList.value.find((v) => v.washedlabelAdditionId === _unref(form).washedlabelAdditionId) ?? {},
                        style: {"width":"100%","height":"100%"}
                      }, null, 8, ["washData"])
                    ])
                  ])
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(t)('客户商品规格')), 1),
              _createVNode(_component_el_tooltip, {
                effect: "light",
                placement: "top",
                "popper-class": "tool-tip-no-border"
              }, {
                content: _withCtx(() => [
                  _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(t)('填写的客户商品规格将打印在水洗标上')), 1)
                ]),
                default: _withCtx(() => [
                  _hoisted_19
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                prop: "washedlabelSpecification",
                style: {"flex":"1"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    placeholder: _unref(t)('示例：L码，红色等'),
                    class: "sku-input",
                    modelValue: _unref(form).washedlabelSpecification,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).washedlabelSpecification) = $event)),
                    maxlength: 20,
                    disabled: __props.isBatchEdit
                  }, null, 8, ["placeholder", "modelValue", "disabled"]),
                  (__props.isBatchEdit)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_unref(t)('无法批量操作，请去单个商品上维护')), 1))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]))
      ]),
      _: 1
    }, 8, ["model"])
  ], 4))
}
}

})